/**
 * Converts a UUID to a base64-encoded string.
 *
 * @param {string} uuid - The UUID to encode.
 * @returns {string} The base64-encoded UUID.
 */
export function uuidToBase64(uuid: string): string {
  if (!uuid) {
    return '';
  }
  const hex = uuid.replace(/-/g, '');
  const bytes: number[] = [];
  for (let i = 0; i < 16; i++) {
    bytes.push(parseInt(hex.slice(i * 2, i * 2 + 2), 16));
  }

  const base64 = btoa(String.fromCharCode(...bytes));
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    '=',
  );
  return padded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
